import { Log } from '@/types/logs'
import { IMechanicalInformation, MechanicalInformationRequestBody } from '@/types/mechanicalInformation'

export const formatMechanicalInformationRequestBody = (
    requestBody: MechanicalInformationRequestBody,
    log?: Log
): IMechanicalInformation | null => {
    if (!log) {
        return null
    }

    return {
        tranzauraUsageType: requestBody.tranzauraUsageType,
        timeEngineeringContactedDetails: requestBody.timeEngineeringContactedDetails || '',
        engineeringStatement: requestBody.engineeringStatement || '',
        busAuthorizedStatus: requestBody.busAuthorizedStatus,
        subbedBonnetNumber: requestBody.subbedBonnetNumber || '',
        timeCleared: requestBody.timeCleared || '',
        substitutionTime: requestBody.substitutionTime || '',
        id: requestBody.id,
        logId: log.id,
    } as IMechanicalInformation
}
